// images
import familyGatheringImg from '../assets/homepage/family-gathering-mobile.jpg'
import familyGatheringImgTab from '../assets/homepage/family-gathering-tablet.jpg'
import familyGatheringImgDt from '../assets/homepage/family-gathering-desktop.jpg'
import specialEventsImg from '../assets/homepage/special-events-mobile.jpg'
import specialEventsImgTab from '../assets/homepage/special-events-tablet.jpg'
import specialEventsImgDt from '../assets/homepage/special-events-desktop.jpg'
import socialEventsImg from '../assets/homepage/social-events-mobile.jpg'
import socialEventsImgTab from '../assets/homepage/social-events-tablet.jpg'
import socialEventsImgDt from '../assets/homepage/social-events-desktop.jpg'

// Static data for events section
export const eventsData = [
    {
        name: 'Family Gathering',
        paragraph:
            'We love catering for entire families. So please bring everyone along for a special meal with your loved ones. We’ll provide a memorable experience for all.',
        img: [familyGatheringImg,familyGatheringImgTab,familyGatheringImgDt],
    },
    {
        name: 'Special Events',
        paragraph:
            'Whether it’s a romantic dinner or special date you’re celebrating with others we’ll look after you. We’ll be sure to mark your special date with an unforgettable meal.',
        img: [specialEventsImg,specialEventsImgTab,specialEventsImgDt],
    },
    {
        name: 'Social Events',
        paragraph:
            'Are you looking to have a larger social event? No problem! We’re more than happy to cater for big parties. We’ll work with you to make your event a hit with everyone.',
        img: [socialEventsImg,socialEventsImgTab,socialEventsImgDt],
    },
]